<template>
    <document-list v-if="!isMediaOpen" @open-media="showMedia" />
    <document-show v-else :mediaBase64="mediaAsBase64" @close="closeMedia()" />
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import DocumentList from "../../documents/DocumentList.vue";
import DocumentShow from "../../documents/DocumentShow.vue";
import { ref } from "vue";
import { useStore } from "vuex";
import { MEDIA_TYPES, STORE_TYPES } from "../../../store/types";

export default defineComponent({
    components: { DocumentList, DocumentShow },
    setup() {
        const store = useStore();
        const isMediaOpen = ref(false);
        const mediaAsBase64 = ref("");
        function showMedia(media) {
            fetchMediaAsBase64(media);
        }
        async function fetchMediaAsBase64(mediaDoc) {
            const response = await store.dispatch(
                `${STORE_TYPES.MEDIA}/${MEDIA_TYPES.FETCH_MEDIA_AS_BASE}`,
                {
                    media: { id: mediaDoc.id },
                }
            );
            console.log(response.data);
            if (response.data) {
                mediaAsBase64.value = response.data;
                isMediaOpen.value = true;
            }
        }
        function closeMedia() {
            isMediaOpen.value = false;
            mediaAsBase64.value = "";
        }
        return { isMediaOpen, showMedia, mediaAsBase64, closeMedia };
    },
});
</script>
